import React from 'react';
import { motion } from 'framer-motion';
import { useAgents } from '../../contexts/AgentContext';
import SafeIcon from '../../common/SafeIcon';
import { FiClock, FiMic, FiPhone, FiTrendingUp } from 'react-icons/fi';


const AgentStats = () => {
  const { getAgentStats } = useAgents();
  const stats = getAgentStats();

  const statCards = [
    {
      title: 'Total Agents',
      value: stats.total,
      icon: FiMic,
      color: 'blue',
      description: `${stats.active} active, ${stats.inactive} inactive`
    },
    {
      title: 'Calls This Month',
      value: stats.totalCalls,
      icon: FiPhone,
      color: 'green',
      description: `${stats.successfulCalls} successful`
    },
    {
      title: 'Average Success Rate',
      value: `${stats.avgSuccessRate}%`,
      icon: FiTrendingUp,
      color: 'purple',
      description: 'Across all agents'
    },
    {
      title: 'Avg Call Duration',
      value: stats.avgDuration,
      icon: FiClock,
      color: 'orange',
      description: 'Per successful call'
    }
  ];

  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    orange: 'from-orange-500 to-orange-600'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards.map((stat, index) => (
        <motion.div
          key={stat.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 card-hover"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.title}</p>
              <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
              <p className="text-sm text-gray-500 mt-1">{stat.description}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg bg-gradient-to-r ${colorClasses[stat.color]} flex items-center justify-center`}>
              <SafeIcon icon={stat.icon} className="text-white text-xl" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default AgentStats;